var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnlyLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 341,
    viewBox: "0 0 600 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.511 53.0223C494.028 25.9744 464.686 4.00234 437.012 4.00234C400.994 4.00234 379.996 34.3182 370.748 52.2574C364.073 64.6341 358.302 74.9943 352.739 84.9374C344.743 99.2609 337.234 112.75 328.264 130.064L319.642 146.682C298.783 186.802 277.923 226.991 257.133 267.111C253.17 274.759 245.521 277.471 237.734 273.994C232.727 271.769 230.572 267.737 230.572 260.436V254.665C230.572 240.132 230.641 225.67 230.572 211.138V185.272C230.433 159.128 230.294 132.149 229.807 105.588C229.459 88.9007 224.662 72.6303 215.344 57.4028C193.998 22.0806 162.361 2.88984 121.407 0.247626C97.3489 -1.28207 75.1682 4.28047 55.4212 16.7962C19.1951 39.8808 0.630132 72.8389 0.352005 114.906C-0.0651861 162.813 0.00434574 211.555 0.00434574 258.697C0.00434574 283.52 0.00434574 308.413 0.00434574 333.236C0.00434574 334.765 0.212941 336.921 1.74264 338.45C3.27234 339.98 5.28876 340.119 7.16612 340.119C19.6123 340.05 32.4062 340.05 44.9914 340.119H58.8283C61.9572 340.119 66.0596 339.424 66.0596 333.305V199.734C66.0596 171.922 66.0596 144.109 66.0596 116.366C66.0596 106.979 68.2846 98.4961 72.8737 90.4304C80.6613 76.6631 93.8723 67.624 109.1 65.6075C124.258 63.5911 139.416 68.806 150.541 79.9311C158.954 88.3444 164.447 102.668 164.447 116.366C164.517 165.664 164.447 225.809 164.447 275.037C164.447 276.08 164.03 301.529 182.734 320.442C195.597 333.444 214.162 340.05 238.29 340.05C258.802 340.05 292.594 340.05 312.063 303.476L425.956 90.5695C428.459 85.9108 431.032 84.3116 436.177 84.3116C440.697 84.3116 443.409 86.7452 445.217 92.3773C457.246 130.064 519.824 306.466 528.794 334.626C530.045 338.45 532.34 340.189 536.512 340.119H599.299C599.299 340.119 511.202 80.9741 502.441 52.9527L502.511 53.0223Z",
    fill: "url(#paint0_linear_10569_233946)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10569_233946",
    x1: 0.00434574,
    y1: 170.044,
    x2: 599.369,
    y2: 170.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#46E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E14696"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyLetter);
export default __webpack_public_path__ + "static/media/logoOnlyLetter.a1bc9e82dc6388b92c36fd657c2efec4.svg";
export { ForwardRef as ReactComponent };